<template>
  <div>
	<!-- Your template content goes here -->
  </div>
</template>

<script>
export default {
  name: 'FeedbackForm',
  data() {
	return {
	  // Your data properties go here
	};
  },
  methods: {
	// Your methods go here
  }
};
</script>
